<template>
  <v-card flat style="background-color: #f1f1f1;">
    <v-container grid-list-md text-xs-center>
      <v-card-text>
        <v-layout row>
          <v-flex xs2>
            <v-text-field
              prefix="#"
              label="Alert (in Days)"
              readonly
              v-model="invoiceData.duration"
            ></v-text-field>
          </v-flex>

          <v-flex xs2>
            <v-text-field prefix="#" label="Invoice Id" readonly v-model="invoiceData.invoiceId"></v-text-field>
          </v-flex>

          <v-flex xs2 offset-xs6>
            <v-text-field
              label="Invoice Date"
              readonly
              :value="new Date(invoiceData.date).toLocaleDateString('en-GB')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-data-table
        :headers="Itemheaders"
        :items="invoiceData.items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.productName }}</td>
          <td class="text-xs-left">{{ props.item.HSN_code }}</td>
          <td>{{ props.item.taxableGST_rate }}</td>
          <td>{{ props.item.rate }}</td>
          <td>{{ props.item.unit }}</td>
          <td>{{ props.item.quantity }}</td>
          <td>{{ props.item.basicPrice }}</td>
          <td>{{ props.item.GSTValue }}</td>
          <td>{{ props.item.totlePrice }}</td>
          <td>{{props.item.CGST_val}} ₹ ({{props.item.CGST}} %)</td>
          <td>{{props.item.SGST_val}} ₹ ({{props.item.SGST}} %)</td>
          <td>{{props.item.IGST_val}} ₹ ({{props.item.IGST}} %)</td>
        </template>
        <template slot="no-data">No Items</template>
      </v-data-table>
    </v-container>

    <v-tabs v-model="tab" centered icons-and-text background-color="primary">
      <v-tab href="#tab-1">E-WAY BILL</v-tab>
      <v-tab href="#tab-2">VIEW E-WAY BILL</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :value="'tab-1'">
        <v-layout row style="margin: 20px;" wrap>
          <v-flex xs12 s6 md3 style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">E-WAY DETAILS</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field label="E-way Bill no" v-model="ebillDetails.billNo"></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerBillDate"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.billDate"
                    label="E-way Bill Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    v-model="ebillDetails.billDate"
                    @input="datepickerBillDate = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field disabled label="Generated By" v-model="ebillDetails.generatedBy"></v-text-field>
                <v-text-field
                  slot="activator"
                  label="Valid From"
                  prepend-icon="event"
                  :value="new Date(invoiceData.date).toLocaleDateString('en-GB')"
                  disabled
                ></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerValidUntil"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.validUntil"
                    label="Valid Untill"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    v-model="ebillDetails.validUntil"
                    @input="datepickerValidUntil = false"
                  ></v-date-picker>
                </v-menu>
                <!-- <v-text-field
                  disabled
                  label="GSTIN of Supplier"
                  v-model="ebillDetails.GSTofSupplier"
                ></v-text-field>
                <v-text-field 
                  label="GSTIN of Receipient/Consignee" 
                  v-model="ebillDetails.GSTofReceipient">
                </v-text-field> -->
                <!-- <v-text-field readonly @click="addressDialogOpen('GSTofReceipient',null)" label="GSTIN of Receipient" v-model="ebillDetails.GSTofReceipient"></v-text-field> -->
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- <v-flex xs12 s6 md3 v-if="firm" style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">FIRM DETAILS</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field disabled label="Firm Name" v-model="firm.name"></v-text-field>
                <v-text-field disabled label="Proprietor Name" v-model="firm.proprietor"></v-text-field>
                <v-text-field disabled label="GST Number" v-model="firm.GST_number"></v-text-field>
                <v-text-field disabled label="PAN Number" v-model="firm.panNumber"></v-text-field>
                <v-text-field disabled outlined label="Address" v-model="firm.address"></v-text-field>
                <v-text-field disabled label="Mobile Number" v-model="firm.mobileNumber"></v-text-field>
                <v-text-field disabled label="Email" v-model="firm.email"></v-text-field>
                <v-text-field disabled label="Website" v-model="firm.website"></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex> -->

          <v-flex xs12 s6 md3 v-if="customer" style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">RECEIPIENT DETAILS</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field disabled label="Firm Name" v-model="customer.name"></v-text-field>
                <v-text-field disabled label="Proprietor Name" v-model="customer.propName"></v-text-field>
                <v-text-field disabled label="GST Number" v-model="customer.GST_number"></v-text-field>
                <v-textarea disabled   box label="Address" v-model="customer.address"></v-textarea>
                <v-text-field disabled label="Mobile Number" v-model="customer.mobile"></v-text-field>
                <v-text-field disabled label="State State" v-model="customer.state"></v-text-field>
                <v-text-field disabled label="State Code" v-model="customer.stateCode"></v-text-field>
                <v-text-field disabled label="Email" v-model="customer.email"></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 s6 md3 v-if="consignee" style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">CONSIGNEE DETAILS</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field label="Firm Name" v-model="consignee.name"></v-text-field>
                <v-text-field label="Proprietor Name" v-model="consignee.propName"></v-text-field>
                <v-text-field label="GST Number" v-model="consignee.GST_number"></v-text-field>
                <v-textarea   box label="Address" v-model="consignee.address"></v-textarea>
                <v-text-field label="Mobile Number" v-model="consignee.mobile" :rules="mobile.rules"></v-text-field>
                <v-text-field label="State State" v-model="consignee.state"></v-text-field>
                <v-text-field label="State Code" v-model="consignee.stateCode"></v-text-field>
                <v-text-field label="Email" v-model="consignee.email"></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 s6 md3 style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">TRANSPORTATION DETAILS</h3>
              </v-card-title>
              <v-card-text>
                <v-select
                  v-model="ebillDetails.transportationDetails.mode"
                  :items="['Road','Train','Aeroplane']"
                  label="Mode of Transport"
                />
                <v-text-field label="Vehicle Number" v-model="transportationDetails.vehicleNo"></v-text-field>
                <v-text-field label="Driver Name" v-model="transportationDetails.driverName"></v-text-field>
                <v-text-field
                  label="Driver Mobile Number"
                  v-model="transportationDetails.driverNumber"
                  :rules="mobile.rules"
                ></v-text-field>
                <!-- <v-menu
                  :close-on-content-click="false"
                  v-model="datepicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.billDate"
                    label="Supply Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="ebillDetails.billDate"
                    @input="datepicker = false"
                  ></v-date-picker>
                </v-menu>
                <v-textarea v-if="consignee" box label="Supply Place" v-model="consignee.address"></v-textarea> -->
                <v-text-field
                  disabled
                  label="GSTIN of Supplier"
                  v-model="ebillDetails.GSTofSupplier"
                ></v-text-field>
                <v-textarea
                  box
                  label="Place Of Dispatch"
                  readonly
                  v-model="firm.address"
                ></v-textarea>
                <v-text-field 
                  label="GSTIN of Receipient/Consignee" 
                  v-model="ebillDetails.GSTofReceipient">
                </v-text-field>
                <!-- @click="addressDialogOpen('placeOfDelivery',null)" -->
                <v-textarea
                  box
                  label="Place Of Delivery"
                  readonly 
                  v-model="consignee.address"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 style="padding: 10px;">
            <v-btn class="primary white--text" flat @click="printInvoice()">Print</v-btn>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item :value="'tab-2'">
        <v-layout row style="margin: 20px;" wrap>
          <v-flex xs12 s6 md4 style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">E-WAY DETAILS</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field label="E-way Bill no" v-model="ebillDetails.billNo"></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerBillDate"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.billDate"
                    label="E-way Bill Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    v-model="ebillDetails.billDate"
                    @input="datepickerBillDate = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field disabled label="Generated By" v-model="ebillDetails.generatedBy"></v-text-field>
                <v-text-field
                  slot="activator"
                  label="Valid From"
                  prepend-icon="event"
                  :value="new Date(invoiceData.date).toLocaleDateString('en-GB')"
                  disabled
                ></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerValidUntil"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.validUntil"
                    label="Valid Untill"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    v-model="ebillDetails.validUntil"
                    @input="datepickerValidUntil = false"
                  ></v-date-picker>
                </v-menu>
                <!-- <v-text-field
                  disabled
                  label="GSTIN of Supplier"
                  v-model="ebillDetails.GSTofSupplier"
                ></v-text-field>
                <v-text-field 
                  label="GSTIN of Receipient/Consignee" 
                  v-model="ebillDetails.GSTofReceipient">
                </v-text-field> -->
                <!-- <v-text-field readonly @click="addressDialogOpen('GSTofReceipient',null)" label="GSTIN of Receipient" v-model="ebillDetails.GSTofReceipient"></v-text-field> -->
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 s6 md4 style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">PART - A</h3>
              </v-card-title>
              <v-card-text>
                <!-- @click="addressDialogOpen('placeOfDispatch',null)" -->
                <v-text-field
                  disabled
                  label="GSTIN of Supplier"
                  v-model="ebillDetails.GSTofSupplier"
                ></v-text-field>
                <v-textarea
                  box
                  label="Place Of Dispatch"
                  readonly
                  v-model="firm.address"
                ></v-textarea>
                <v-text-field 
                  label="GSTIN of Receipient/Consignee" 
                  v-model="ebillDetails.GSTofReceipient">
                </v-text-field>
                <!-- @click="addressDialogOpen('placeOfDelivery',null)" -->
                <v-textarea
                  box
                  label="Place Of Delivery"
                  readonly 
                  v-model="consignee.address"
                ></v-textarea>
                <v-text-field label="Document No" v-model="ebillDetails.documentNo"></v-text-field>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerDocumentDate"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.documentDate"
                    label="Document Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    v-model="ebillDetails.documentDate"
                    @input="datepickerDocumentDate = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field label="Value Of Goods" v-model="ebillDetails.valueOfGoods"></v-text-field>
                <v-textarea
                  box
                  label="Reason Of Transportation"
                  v-model="ebillDetails.reasonOfTransportation"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 s6 md4 style="padding: 10px;">
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary">PART - B</h3>
              </v-card-title>
              <v-card-text>
                <v-select
                  v-model="ebillDetails.transportationDetails.mode"
                  :items="['Road','Train','Aeroplane']"
                  label="Mode of Transport"
                />
                <v-text-field
                  label="Vehicle No"
                  v-model="ebillDetails.transportationDetails.vehicleNo"
                ></v-text-field>
                <v-textarea
                  box
                  label="From Address"
                  v-model="firm.address"
                  readonly
                  @click="addressDialogOpen('transportationDetails','from')"
                ></v-textarea>
                <v-textarea
                  box
                  label="To Address"
                  v-model="consignee.address"
                  readonly
                  @click="addressDialogOpen('transportationDetails','to')"
                ></v-textarea>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerDepartureDate"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="ebillDetails.billDate"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    v-model="ebillDetails.billDate"
                    @input="datepickerBillDate = false"
                  ></v-date-picker>
                </v-menu>
                <!-- <v-text-field
                  label="Departure Date"
                  v-model="ebillDetails.transportationDetails.departureDate"
                ></v-text-field> -->
                <v-text-field
                  label="Entered By"
                  v-model="ebillDetails.transportationDetails.enteredBy"
                ></v-text-field>
                <v-text-field
                  label="CEWB Number"
                  v-model="ebillDetails.transportationDetails.CEWBno"
                ></v-text-field>
                <!-- <v-textarea
                  box
                  label="Reason Of Transportation"
                  v-model="ebillDetails.transportationDetails.remark"
                ></v-textarea> -->
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="addressDialog" max-width="800px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Select Address</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-select v-model="address.village" :items="gVillage" label="Village" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select v-model="address.block" :items="gBlock" label="Block" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select v-model="address.tehsil" :items="gTehsil" label="Tehsil" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select v-model="address.district" :items="gDistrict" label="District" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select v-model="address.state" :items="gState" item-text="state" label="State" />
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Full Address" v-model="address.fullAddress"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="addressDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="setAddress">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToEwayBillType1, convertToEwayBillType2 } from "../../../utils/pdfmake";

export default {
  components: {},
  props: ["invoiceData", "bank", "firm", "seller", "buyer","termsAndConditions","gstTotal"],
  data() {
    return {
      isBuyer: null,
      customer: null,
      Itemheaders: [
        { text: "Product Name", sortable: false, value: "productName" },
        { text: "HSN code", sortable: false, value: "HSN_code" },
        { text: "GST", sortable: false, value: "taxableGST_rate" },
        { text: "Rate", sortable: false, value: "rate" },
        { text: "Unit", sortable: false, value: "unit" },
        { text: "Quantity", sortable: false, value: "quantity" },
        { text: "Basic Price", sortable: false, value: "basicPrice" },
        { text: "GST value", sortable: false, value: "GSTValue" },
        { text: "Total Price", sortable: false, value: "totlePrice" },
        { text: "CGST value ( %)", sortable: false, value: "CGST" },
        { text: "SGST value ( %)", sortable: false, value: "SGST" },
        { text: "IGST value ( %)", sortable: false, value: "IGST" }
      ],
      transportationDetails: {
        vehicleNo: null,
        driverName: null,
        driverNumber: null,
        supplyDate: null
      },
      mobile: {
        value: "",
        rules: [
          v =>
            /^$/.test(v) ||
            /^(\+91|\+91\-|0)?[789]\d{9}$/.test(v) ||
            "Mobile number is wrong"
        ]
      },
      consignee: null,
      datepicker: false,
      datepickerBillDate: false,
      datepickerValidFrom: false,
      datepickerValidUntil: false,
      datepickerDocumentDate: false,
      datepickerDepartureDate: false,
      tab: null,
      ebillDetails: {
        billNo: null,
        billDate: null,
        generatedBy: null,
        validFrom: null,
        validUntil: null,
        GSTofSupplier: null,
        GSTofReceipient: null,
        placeOfDispatch: null, //add
        placeOfDelivery: null, //add
        documentNo: null,
        documentDate: null,
        valueOfGoods: null,
        reasonOfTransportation: null,
        transportationDetails: {
          mode: null,
          vehicleNo: null,
          from: null, //ad
          to: null, // add
          departureDate: null,
          enteredBy: null,
          CEWBno: null,
          remark: null
        }
      },
      address: {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      },
      addressDialog: false
    };
  },
  computed: {
    ...mapGlobalGetters({
      gVillage: "village",
      gBlock: "block",
      gTehsil: "tehsil",
      gDistrict: "district",
      gState: "state",
      gCountry: "country"
    })
  },
  methods: {
    getAddress(item) {
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    setAddress() {
      if (this.address.field1 && this.address.field2) {
        this.ebillDetails[this.address.field1][
          this.address.field2
        ] = this.address.fullAddress;
      } else if (this.address.field1) {
        this.ebillDetails[this.address.field1] = this.address.fullAddress;
      }
      this.addressDialog = false;
    },
    resetAddress() {
      this.address = {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      };
    },
    checkUser() {
      if (this.buyer && "name" in this.buyer) {
        this.isBuyer = false;
        this.customer = this.buyer;
        this.customer.address = this.getAddress(this.buyer);
        this.consignee = JSON.parse(JSON.stringify(this.customer));
      } else if (this.seller && "name" in this.seller) {
        this.isBuyer = true;
        this.customer = this.$listenersseller;
        this.customer.address = this.getAddress(this.seller);
        this.consignee = JSON.parse(JSON.stringify(this.customer));
      }
      this.getEbillDetails();
    },
    addressDialogOpen(field1, field2) {
      this.address.field1 = field1;
      this.address.field2 = field2;
      this.addressDialog = true;
    },
    getEbillDetails() {
      this.ebillDetails.generatedBy =
        this.firm && this.firm.name + " - " + this.firm.GST_number;
      this.ebillDetails.validFrom = this.invoiceData && this.invoiceData.date;
      this.ebillDetails.GSTofSupplier = this.firm && this.firm.GST_number;
      this.ebillDetails.GSTofReceipient =
        this.customer && this.customer.GST_number;
      this.ebillDetails.valueOfGoods =
        this.invoiceData && this.invoiceData.totalAmount;
      this.ebillDetails.transportationDetails.enteredBy =
        this.firm && this.firm.GST_number;
    },
    printInvoice() {
      let doc = convertToEwayBillType2({
        invoiceData : this.invoiceData,
        bank : this.bank,
        firm : this.firm,
        customer : this.customer,
        ebillDetails : this.ebillDetails,
        consignee : this.consignee,
        transportationDetails : this.transportationDetails,
        terms : this.termsAndConditions[0],
        gstTotal : this.gstTotal
      });
      // console.log(doc)
      this.printDialog = true;
      pdfMake.createPdf(doc).download();
    }
  },
  watch: {
    seller(newVal, oldVal) {
      if (newVal) {
        this.checkUser();
      }
    },
    buyer(newVal, oldVal) {
      if (newVal) {
        this.checkUser();
      }
    },
    firm(newVal, oldVal) {
      if (newVal) {
        this.firm.address = this.getAddress(this.firm);
      }
    },
    "address.village": function(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.block": function(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.tehsil": function(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.district": function(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.state": function(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "invoiceData.totalAmount": {
      handler(newVal, oldVal) {
        this.getEbillDetails();
      },
      deep: true
    },
    "invoiceData.firm": {
      handler(newVal, oldVal) {
        this.getEbillDetails();
      },
      deep: true
    }
  },
  created() {
    this.checkUser();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Buyers/Invoice/PrintInvoice.vue